(function (Drupal, once) {
  // Drupal.behaviors.hoverImageFollow = {
  //   attach: function (context, settings) {
  //     if (window.innerWidth < 768) return // Skip on smaller screens
  //
  //     once('hover-image-behavior', '.hover-container', context).forEach(function (container) {
  //       const hoverImageWrapper = container.querySelector('.category-hover-view');
  //
  //       container.addEventListener('mouseover', () => {
  //         hoverImageWrapper.style.opacity = '1';
  //       });
  //
  //       container.addEventListener('mousemove', (e) => {
  //         const imageWidth = hoverImageWrapper.offsetWidth;
  //         const imageHeight = hoverImageWrapper.offsetHeight;
  //         const pageWidth = window.innerWidth;
  //         const pageHeight = window.innerHeight;
  //
  //         let offsetX = 20;
  //         let offsetY = 20;
  //
  //         // Flip left if cursor too close to the right edge
  //         if (e.clientX + imageWidth + offsetX > pageWidth) {
  //           offsetX = -imageWidth - 20;
  //         }
  //
  //         // Flip above if cursor too close to the bottom edge
  //         if (e.clientY + imageHeight + offsetY > pageHeight) {
  //           offsetY = - imageHeight - 20;
  //         }
  //
  //         const translateX = e.clientX + offsetX;
  //         const translateY = e.clientY + offsetY;
  //
  //         hoverImageWrapper.style.transform = `translate(${translateX}px, ${translateY}px)`;
  //       });
  //
  //       container.addEventListener('mouseleave', () => {
  //         hoverImageWrapper.style.opacity = '0';
  //       });
  //     });
  //   }
  // };

  // Drupal.behaviors.hoverImageModal = {
  //   attach: function (context, settings) {
  //     // if (window.innerWidth >= 768) return // Skip on medium+ screens
  //
  //     once('hover-modal-image', '.modal-body', context).forEach(function (container){
  //       const defaultImg = container.querySelector('.category-default-view img');
  //       const hoverImg = container.querySelector('.category-hover-view img');
  //       const modalImg = document.getElementById('modalImage');
  //
  //       if (!defaultImg || !hoverImg || !modalImg) return;
  //
  //       defaultImg.setAttribute('data-bs-toggle', 'modal');
  //       defaultImg.setAttribute('data-bs-target', '#imageModal');
  //
  //       defaultImg.addEventListener('click', () => {
  //         modalImg.src = hoverImg.src;
  //         modalImg.alt = hoverImg.alt || 'Preview';
  //       });
  //     });
  //   }
  // };

    Drupal.behaviors.modalImageHover = {
      attach: function (context, settings) {
        // if (window.innerWidth <= 768) return

        const modal = once('modal-image-hover-init', '#image-modal', context).shift();
        if (!modal) return;

        const modalBody = modal.querySelector('.modal-body');

        once('modal-image-hover', '.category-default-view', context).forEach(img => {
          const container = img.closest('.hover-container');
          if (!container) return;

          const largeImg = container.querySelector('.category-hover-view img');
          if (!largeImg) return;

          img.addEventListener('click', function () {
            modalBody.innerHTML = `<img src="${largeImg.src}" alt="" style="max-width:100%; height:auto;">`;
            const bootstrapModal = new bootstrap.Modal(modal);
            bootstrapModal.show();
          });

          img.addEventListener('mouseleave', function () {
            const bootstrapModal = bootstrap.Modal.getInstance(modal);
            if (bootstrapModal) {
              bootstrapModal.hide();
            }
          });
        });
      }
    };

    Drupal.behaviors.videoModalFromBlock = {
      attach: function (context, settings) {
        const modal = once('video-modal-init', '#video-modal', context).shift();
        if (!modal) return;

        const modalBody = modal.querySelector('.modal-body');

        once('video-modal-trigger', '.open-video-modal', context).forEach(button => {
          const videoContent = document.getElementById('video-modal-content');
          button.addEventListener('click', function (){
            if (videoContent) {
              modalBody.innerHTML = videoContent.innerHTML;
            }
          });
        });

        modal.addEventListener('hidden.bs.modal', function () {
          modalBody.innerHTML = '';
        });
      }
    };

  })(Drupal, once);
